/*
 * Huggler — infinite scroll for collection pages (Dawn 15.3.0)
 * Progressive enhancement: numbered pagination stays as a no-JS/SEO fallback
 * but is hidden here, and further pages load automatically on scroll.
 * Works with Dawn's facet filtering/sorting (re-inits when the grid is replaced).
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return; // graceful fallback to numbered pagination

  // one-time keyframes for the loading spinner
  if (!document.getElementById('hug-inf-style')) {
    var st = document.createElement('style');
    st.id = 'hug-inf-style';
    st.textContent =
      '@keyframes hugInfSpin{to{transform:rotate(360deg)}}' +
      '.hug-inf-spinner{display:none;justify-content:center;align-items:center;padding:2.4rem 0;color:rgb(var(--color-foreground,18,18,18))}' +
      '.hug-inf-spinner svg{animation:hugInfSpin .9s linear infinite}';
    document.head.appendChild(st);
  }

  function init() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var grid = container.querySelector('#product-grid');
    if (!grid || grid.dataset.hugInfInit === '1') return;

    var nextUrl = grid.getAttribute('data-next-url') || '';
    var sectionId = grid.getAttribute('data-id') || '';

    // hide numbered pagination now that JS is driving the loading
    var pag = container.querySelector('.pagination-wrapper');
    if (pag) pag.style.display = 'none';

    if (!nextUrl) return; // single page — nothing to load
    grid.dataset.hugInfInit = '1';

    var spinner = document.createElement('div');
    spinner.className = 'hug-inf-spinner';
    spinner.setAttribute('data-hug-inf-spinner', '');
    spinner.innerHTML =
      '<svg width="34" height="34" viewBox="0 0 66 66" aria-hidden="true">' +
      '<circle cx="33" cy="33" r="29" fill="none" stroke="currentColor" stroke-width="6" ' +
      'stroke-linecap="round" stroke-dasharray="110 70"/></svg>';

    var sentinel = document.createElement('div');
    sentinel.setAttribute('data-hug-inf-sentinel', '');
    sentinel.style.cssText = 'width:100%;height:1px;';

    grid.parentNode.appendChild(spinner);
    grid.parentNode.appendChild(sentinel);

    var loading = false;

    function fetchUrl(url) {
      // render just this section for a lighter payload
      var join = url.indexOf('?') === -1 ? '?' : '&';
      return sectionId ? url + join + 'section_id=' + encodeURIComponent(sectionId) : url;
    }

    function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;
      spinner.style.display = 'flex';
      fetch(fetchUrl(nextUrl))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          if (newGrid) {
            var items = newGrid.querySelectorAll(':scope > li');
            var frag = document.createDocumentFragment();
            for (var i = 0; i < items.length; i++) frag.appendChild(document.importNode(items[i], true));
            grid.appendChild(frag);
            nextUrl = newGrid.getAttribute('data-next-url') || '';
          } else {
            nextUrl = '';
          }
        })
        .catch(function () { /* keep nextUrl; will retry on next intersection */ })
        .then(function () {
          loading = false;
          spinner.style.display = 'none';
          if (!nextUrl) teardown();
        });
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { loadNext(); break; }
      }
    }, { rootMargin: '700px 0px' });
    observer.observe(sentinel);

    // Fallback trigger in case IntersectionObserver doesn't fire: throttled scroll/resize.
    function nearBottom() {
      var r = sentinel.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      return r.top - vh < 700;
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      setTimeout(function () {
        ticking = false;
        if (nextUrl && nearBottom()) loadNext();
      }, 120);
    }
    function teardown() {
      observer.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (spinner && spinner.parentNode) spinner.remove();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function boot() {
    init();
    // Dawn replaces #ProductGridContainer contents on filter/sort — re-init then.
    var container = document.getElementById('ProductGridContainer');
    if (container && !container.dataset.hugInfObserved) {
      container.dataset.hugInfObserved = '1';
      new MutationObserver(function () { init(); }).observe(container, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
